import React from "react";

export default function TopBar() {
  return (
    <div className="bg-navy text-white text-sm" data-testid="utility-top-bar">
      <div className="max-w-content mx-auto px-4 sm:px-6 flex items-center justify-between h-9">
        <span className="text-white/80" data-testid="top-bar-hours">
          Mon–Fri: 9:00 AM – 6:00 PM ET
        </span>
        <div className="flex items-center gap-4">
          <a
            href="tel:+19842612925"
            className="text-white/90 hover:text-gold transition-colors"
            data-testid="top-bar-phone"
          >
            984-261-2925
          </a>
          <span className="text-white/30">|</span>
          <a
            href="/contact"
            className="text-gold hover:text-white transition-colors"
            data-testid="top-bar-signup"
          >
            Sign Up
          </a>
        </div>
      </div>
    </div>
  );
}
